import { createContext, useContext } from "react";

/**
 * Container-alvo para portais de overlays (Dialog/AlertDialog/Sheet/Popover/menus/Select).
 *
 * Por padrão é `null` → os primitivos do shadcn/Radix usam o default deles (`document.body`), então as
 * superfícies de cliente/entregador seguem exatamente como antes. A navegação por abas internas do admin
 * fornece aqui o nó DOM do painel da aba: assim todo overlay é portado PARA DENTRO do painel. Quando a aba
 * fica inativa (`display:none` + `inert`), o overlay some e perde foco junto com o painel — e continua
 * montado, preservando os dados já preenchidos (ex.: formulário dentro de um Dialog).
 */
const PortalContainerContext = createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

/** Nó-alvo para portais, ou `null` quando não há contexto (→ default `document.body`). */
export function usePortalContainer(): HTMLElement | null {
  return useContext(PortalContainerContext);
}
